var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.options
    ? _c(
        "select",
        {
          staticClass: "input-select",
          style: _vm.style,
          attrs: { disabled: _vm.disabled },
          on: { change: _vm.changeEvent }
        },
        _vm._l(_vm.options, function(option, index) {
          return _c(
            "option",
            { key: index, domProps: { selected: option === _vm.value } },
            [_vm._v("\n    " + _vm._s(option) + "\n  ")]
          )
        }),
        0
      )
    : _c(
        "select",
        {
          staticClass: "input-select",
          style: _vm.style,
          attrs: { disabled: _vm.disabled },
          on: { change: _vm.changeEvent }
        },
        [_vm._t("default")],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }